import React from 'react';
import Loadable from 'react-loadable';

import LoadingState from './components/LoadingState/LoadingState';

const LoadableWidget = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SportsAnimalRacingLandingPageWidget" */ './SportsAnimalRacingLandingPageWidget'
    ),
  modules: ['./SportsAnimalRacingLandingPageWidget'],
  loading: () => <LoadingState />
});

export default LoadableWidget;
